
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { ICell } from '@/model/Locker/lockerInterfaces'
import { IListOrder } from '@/model/Order/orderInterfaces'

type Stage = 'choose' | 'complete-flow';
type Intent = 'only' | 'complete' | null;

@Component({ name: 'LMOpenCellDialog' })
export default class LMOpenCellDialog extends Vue {

  @Prop({ required: true })
  protected cell!: ICell;

  @Prop({ default: null })
  protected order!: IListOrder | null;

  @Prop({ default: false })
  protected submitting!: boolean;

  @Prop({ default: false })
  protected cellOpened!: boolean;

  @Prop({ default: false })
  protected collected!: boolean;

  protected showing: boolean = true;
  protected snapshotOrder: IListOrder | null = null;
  protected stage: Stage = 'choose';
  protected intent: Intent = null;

  protected get displayOrder(): IListOrder | null {
    return this.snapshotOrder || this.order;
  }

  @Watch('cellOpened')
  protected onCellOpenedChange(newVal: boolean) {
    if (!newVal || this.intent === null) return;
    if (this.intent === 'only') {
      this.$emit('close');
    } else {
      this.stage = 'complete-flow';
    }
  }

  protected onClose() {
    this.$emit('close');
  }

  protected onClickOpenOnly() {
    this.intent = 'only';
    this.snapshotOrder = this.order;
    this.$emit('open-cell-only');
  }

  protected onClickOpenAndComplete() {
    this.intent = 'complete';
    this.snapshotOrder = this.order;
    this.$emit('open-and-complete');
  }

  protected onCompleteOrder() {
    this.$emit('open-for-collect');
    this.$emit('close');
  }
}
